import { BalanceAccount, ModuleSetting } from "@models";
import { isAfter, isBefore } from "date-fns";

export function checkAssociatedModuleSetting(
	balanceAccount: BalanceAccount,
	moduleSettings: ModuleSetting[]
) {
	const associatedModuleSettings = moduleSettings.filter(
		(ms) => ms.balanceAccountId === balanceAccount.balanceAccountId
	);

	if (associatedModuleSettings.length === 0) return false;
	const now = new Date(Date.now());

	return associatedModuleSettings.some((ms) => {
		if (isAfter(ms.availableFrom, now)) return false;

		if (ms.availableUntil && isBefore(ms.availableUntil, now)) return false;

		return true;
	});
}

export const NO_ASSOCIATED_MS_MESSAGE =
	"Das Guthabenkonto wird zurzeit nicht verwendet, weil es in den Budgeteinstellungen nicht aktiviert ist.";
